export default __webpack_public_path__ + "static/media/discord-gold.a857ea2a.png";